import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, css, fonts } from '../../Styles';
import { getGraphColor } from '../../Styles/colors';
import { FeedCurve } from '../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall';

// TODO
import FeedCurveViewer from '../curveViewer/feedCurveViewer';
import { useFeedCurves } from '../../Services/Agrisys_GqlDataCaller/FeedDataCalls/useFeedCurves';
import { useAppSelector } from '../../Store';
import { Graph_QL } from '../../Services';

interface FeedCurveCard_Props {
  feedCurve: FeedCurve
  onFeedCurveSelect?: (id: number) => void
}

export default function FeedCurveCard({ feedCurve, onFeedCurveSelect }: FeedCurveCard_Props) {  
  const {t} = useTranslation()
  const [isSectionHovered, setIsSectionHovered] = useState(false);

  const farm = useAppSelector(({activeData}) => activeData.farm)
  const connection = Graph_QL.create({domain: farm ?? ""});

  const {call: getFeedCurves} = useFeedCurves(connection);

  useEffect(() => {
    if (!feedCurve.components || !feedCurve.milestones) {
      getFeedCurves({ids: [feedCurve.feedCurveId], ifFeedCurveInfo: true})
    }
  },[])
  

  if (!feedCurve || !feedCurve.components || !feedCurve.milestones) return <div>{t("noData", {defaultValue: "No Data"})}</div>; //Consider spinner and fetch here if the data is missing

  // Map through the components to find their names and styles
  const feedCurveComponents = feedCurve.components.map(component => {
    return (
      <div
        key={component.feedCurveComponentId}
        style={{
          ...css.colorTag,
          backgroundColor: getGraphColor(component.componentId),
          ...fonts.header,
          ...fonts.fontSize4,
          color: colors.whitePrimary
        }}
      >
        {component.name}
      </div>
    ) 
  });
    
  // Render milestones
  const feedCurveMilestones = feedCurve.milestones.map((milestone, index) => (
    <p key={index} style={{margin: "5px 0", ...fonts.paragraph, ...fonts.fontSize4}}>
      {milestone.name}
    </p>
  ));

  const isDefault = feedCurve.info?.default
  const isActive = feedCurve.info?.active
  
  return (
    <div
      onClick={onFeedCurveSelect ? () => onFeedCurveSelect(feedCurve.feedCurveId) : undefined } 
      onMouseEnter={() => setIsSectionHovered(true)}
      onMouseLeave={() => setIsSectionHovered(false)} 
      style={{ 
        cursor: "pointer",
        borderRadius: "10px",
        height: "fit-content",
        breakInside: "avoid",
        marginBottom: "20px",
        border: "5px solid "+colors.greyPrimary, 
        minWidth: "320px",
        width: "100%",
        boxSizing: "border-box",
        filter: isSectionHovered ? 'opacity(0.5)' : 'opacity(1)',
        transition: '0.3s'
      }}>
    
        <div style={{backgroundColor: colors.greyPrimary, height: "50px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", position: "relative" }}>
          <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>{feedCurve.name}</p>
          <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary}}>{t("feed.feedCurve.feedCurve", {defaultValue: "Feed Curve"})} {feedCurve.feedCurveId}</p>
          <div style={{position: "absolute", top: "2px", right: "4px"}}>
            <p style={{...fonts.header, ...fonts.fontSize5, color: colors.blueLightPrimary, textAlign: "right"}}>{ isActive? "• " + t("feed.feedCurve.active", {defaultValue: "Active"}) : ""}</p>
            <p style={{...fonts.header, ...fonts.fontSize5, color: colors.greyLightTertiary, textAlign: "right"}}>{ isDefault? t("default", {defaultValue: "Default"}) : ""}</p>
          </div>
        </div>

        <div style={{backgroundColor: colors.greyLightTertiary, borderRadius: "0px 0px 5px 5px", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px"}}>
          <div style={{display: "grid", gridTemplateColumns: "repeat(2, auto)", gridTemplateRows: "repeat(2, auto)", gap: "2px", backgroundColor: colors.greyLightSecondary}}>
            <div style={{gridArea: "1/1/2/3", backgroundColor: colors.greyLightTertiary}}>
              <FeedCurveViewer data={feedCurve} isMiniature />
            </div>
            
            <div style={{ gridArea: "2/1/3/2", backgroundColor: colors.greyLightTertiary, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "start", gap: "5px", paddingTop: "10px" }}>
              <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary}}>{t("feedCurvePages.components.components", {defaultValue: "Components"})}</p>
              {feedCurveComponents}
            </div>
              
            <div style={{ gridArea: "2/2/3/3", backgroundColor: colors.greyLightTertiary, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "start", gap: "5px", paddingTop: "10px" }}>
              <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary}}>{t("milestones.general.milestones", {defaultValue: "Milestones"})}</p>
              {feedCurveMilestones}
            </div>

          </div>
        </div>

    </div>
  );
}